(function () {
  'use strict';
  if (window.dacRememberMe) return;
  var node = document.querySelector('[data-dac-remember-me-config]');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }

  var marker = 'dac_remember_me';
  var attemptKey = 'dac_rm_attempt_at';
  var signingOut = false;
  var logoutPromise;
  var activeController;

  function getMarker() {
    return document.cookie.split(';').some(function (part) {
      return part.trim().replace(/="1"$/, '=1') === marker + '=1';
    });
  }
  function clearMarker() {
    document.cookie = marker + '=; Max-Age=0; path=/; SameSite=Lax; Secure';
  }
  function setMarker() {
    if (!signingOut) document.cookie = marker + '=1; Max-Age=2592000; path=/; SameSite=Lax; Secure';
  }
  function storageRead() {
    try { return Number(sessionStorage.getItem(attemptKey)) || 0; } catch (_) { return 0; }
  }
  function storageWrite(value) {
    try { sessionStorage.setItem(attemptKey, String(value)); return true; } catch (_) { return false; }
  }
  function storageClear() {
    try { sessionStorage.removeItem(attemptKey); } catch (_) {}
  }

  // Preserve the service's request/signature contract. A service failure must
  // never block storefront navigation or leave an unhandled rejection.
  function request(path, body, timeout, authorization) {
    return new Promise(function (resolve) {
      var finished = false;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      activeController = controller;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
        finish(null);
      }, timeout);
      function finish(value) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (activeController === controller) activeController = null;
        resolve(value);
      }
      var headers = { 'Content-Type': 'application/json' };
      if (authorization) headers.authorization = authorization;
      var options = {
        method: 'POST', mode: 'cors', credentials: 'include',
        redirect: 'error', headers: headers, body: JSON.stringify(body || {})
      };
      if (controller) options.signal = controller.signal;
      Promise.resolve().then(function () { return fetch(config.appUrl + path, options); })
        .then(function (response) {
          if (response.status === 401) clearMarker();
          // /token intentionally returns 400 during the first 20 hours.
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          finish(data && typeof data === 'object' && !Array.isArray(data) ? data : null);
        }, function () { finish(null); });
    });
  }

  function loginTarget(value) {
    if (typeof value !== 'string' || value.length > 8192) return null;
    try {
      var target = new URL(value, 'https://www.diamondartclub.com');
      // persist-login/server.js returns this exact canonical Multipass route.
      if (target.origin !== 'https://www.diamondartclub.com' || target.username || target.password ||
          target.search || target.hash || !/^\/account\/login\/multipass\/[A-Za-z0-9_-]+={0,2}$/.test(target.pathname)) return null;
      return target.href;
    } catch (_) { return null; }
  }

  function clearRememberMe() {
    signingOut = true;
    clearMarker();
    storageClear();
    if (logoutPromise) return logoutPromise;
    if (activeController) activeController.abort();
    logoutPromise = request('/logout', {}, 2000);
    return logoutPromise;
  }
  window.dacRememberMe = { clear: clearRememberMe };

  // Covers both the original account drawer and the new account navigation.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var target;
    try { target = new URL(link.href, location.origin); } catch (_) { return; }
    if ((target.origin !== location.origin && target.origin !== 'https://www.diamondartclub.com') ||
        !/\/(?:account|customer_identity)\/logout\/?$/.test(target.pathname)) return;
    var cleared = clearRememberMe();
    try { if (window.deleteAlreadyPurchased) window.deleteAlreadyPurchased(); } catch (_) {}
    try {
      if (window._swat && typeof window._swat.disconnectShopperContext === 'function') {
        window._swat.disconnectShopperContext(function () {}, function () {});
      }
    } catch (_) {}
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    cleared.then(function () { location.assign(target.href); });
  }, true);

  if (config.usesCustomerIdentity === true) {
    if (getMarker()) clearRememberMe();
    else storageClear();
    return;
  }

  if (typeof window.fetch !== 'function') return;
  if (config.customer) {
    storageClear();
    if (!getMarker()) {
      request('/register', config.customer, 8000, config.authorization).then(function (data) {
        if (data && data.registered === true) setMarker();
      });
    }
  } else if (getMarker() && !/\/account\/(?:logout|login\/multipass)(?:\/|$)/.test(location.pathname)) {
    // Bound automatic redirect retries without disabling future eligible visits.
    if (Date.now() - storageRead() < 60000) return;
    request('/token', { return_to: location.pathname }, 8000).then(function (data) {
      if (signingOut || !data) return;
      var target = loginTarget(data.url);
      if (!target) return;
      // If storage is blocked, consume the marker before navigating so a failed
      // Shopify login cannot repeatedly redirect the browser.
      if (!storageWrite(Date.now())) clearMarker();
      location.replace(target);
    });
  }
})();
